"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XMark = exports.WrongCard = exports.Warning = exports.Visa = exports.TrashCan = exports.SortingArrow = exports.NegativeResult = exports.NavArrow = exports.MasterCard = exports.Jcb = exports.Info = exports.Floppy = exports.Eraser = exports.EMail = exports.DownArrow = exports.Discover = exports.Diners = exports.CreditCardPlaceHolder = exports.CheckMark = exports.Calendar = exports.Amex = exports.AlertNegative = void 0;

var _react = _interopRequireDefault(require("react"));

require("styled-components/macro");

var _ = require("../");

var _styledTheme = require("../styles/styledTheme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trashCan = function trashCan() {
  return _react.default.createElement("path", {
    d: "M9 19c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 \r 1 1v10zm4 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 \r 1v10zm4 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 \r 1v10zm5-17v2h-20v-2h5.711c.9 0 1.631-1.099 1.631-2h5.315c0 .901.73 2 1.631 \r 2h5.712zm-3 4v16h-14v-16h-2v18h18v-18h-2z"
  });
};

var sortingArrow = function sortingArrow() {
  return _react.default.createElement("path", {
    d: "M12 0l8 10h-16l8-10zm8 14h-16l8 10 8-10z"
  });
};

var downArrow = function downArrow() {
  return _react.default.createElement("path", {
    d: "M10 0L5 5 0 0z"
  });
};

var navArrow = function navArrow() {
  return _react.default.createElement("path", {
    d: "M0 3.795l2.995-2.98 11.132 11.185-11.132 \r 11.186-2.995-2.981 8.167-8.205-8.167-8.205zm18.04 8.205l-8.167 8.205 \r 2.995 2.98 11.132-11.185-11.132-11.186-2.995 2.98 8.167 8.206z"
  });
};

var alertNegative = function alertNegative() {
  return _react.default.createElement("path", {
    d: "M16.143 2l5.857 5.858v8.284l-5.857 5.858h-8.286l-5.857-5.858v-8.284l5.857-5.858h8.286zm.828-2h-9.942l-7.029 \r\n7.029v9.941l7.029 7.03h9.941l7.03-7.029v-9.942l-7.029-7.029zm-6.471 6h3l-1 8h-1l-1-8zm1.5 12.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"
  });
}; // const infoCursive = () => <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2.033 16.01c.564-1.789 1.632-3.932 
// 1.821-4.474.273-.787-.211-1.136-1.74.209l-.34-.64c1.744-1.897 5.335-2.326 4.113.613-.763 1.835-1.309 3.074-1.621 4.03-.455 1.393.694.828 1.819-.211.153.25.203.331.356.619-2.498 2.378-5.271 2.588-4.408-.146zm4.742-8.169c-.532.453-1.32.443-1.761-.022-.441-.465-.367-1.208.164-1.661.532-.453 1.32-.442 1.761.022.439.466.367 1.209-.164 1.661z"/>


var info = function info() {
  return _react.default.createElement("path", {
    d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z"
  });
}; //const infoFull = () => <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z"/>


var checkMark = function checkMark() {
  return _react.default.createElement("path", {
    d: "M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"
  });
};

var xMark = function xMark() {
  return _react.default.createElement("path", {
    d: "M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"
  });
};

var email = function email() {
  return _react.default.createElement("path", {
    d: "M0 3v18h24v-18h-24zm6.623 7.929l-4.623 5.712v-9.458l4.623 3.746zm-4.141-5.929h19.035l-9.517 7.713-9.518-7.713zm5.694 7.188l3.824 3.099 3.83-3.104 5.612 6.817h-18.779l5.513-6.812zm9.208-1.264l4.616-3.741v9.348l-4.616-5.607z"
  });
};

var negativeResult = function negativeResult() {
  return _react.default.createElement("path", {
    d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-12v-2h12v2z"
  });
};

var warningTriangle = function warningTriangle() {
  return _react.default.createElement("path", {
    d: "M12 1l-12 22h24l-12-22zm-1 8h2v7h-2v-7zm1 11.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"
  });
};

var floppySave = function floppySave() {
  return _react.default.createElement("path", {
    d: "M15.003 3h2.997v5h-2.997v-5zm8.997 1v20h-24v-24h20l4 4zm-19 5h14v-7h-14v7zm16 4h-18v9h18v-9z"
  });
};

var eraser = function eraser() {
  return _react.default.createElement("path", {
    d: "M5.662 23l-5.369-5.365c-.195-.195-.293-.45-.293-.707 0-.256.098-.512.293-.707l14.929-14.928c.195-.194.451-.293.707-.293.255 0 .512.099.707.293l7.071 7.073c.196.195.293.451.293.708 0 .256-.097.511-.293.707l-11.216 11.219h5.514v2h-12.343zm3.657-2l-5.486-5.486-1.419 1.414 4.076 4.072h2.829zm.456-11.429l-4.528 4.528 5.658 5.659 4.527-4.53-5.657-5.657z"
  });
};

var visa = function visa() {
  return _react.default.createElement("path", {
    d: "M19.662 11.156l.375 1.716h-1.344l.645-1.661.215-.567.109.512zm4.338-5.156v12c0 1.104-.896 2-2 2h-20c-1.104 0-2-.896-2-2v-12c0-1.104.896-2 2-2h20c1.104 0 2 .896 2 2zm-17.146 8.971l2.549-5.929h-1.715l-1.585 4.051-.169-.823-.568-2.73c-.098-.377-.383-.489-.734-.502h-2.611l-.021.123c.635.154 1.203.376 1.701.651l1.44 5.16 1.713-.001zm4.823-5.934h-1.619l-1.012 5.941h1.619l1.012-5.941zm4.625 3.999c.006-.676-.425-1.19-1.359-1.614-.566-.275-.913-.458-.909-.736 0-.247.293-.511.927-.511.53-.008.913.107 1.212.228l.145.068.219-1.287c-.321-.121-.824-.25-1.451-.25-1.6 0-2.727.806-2.737 1.961-.009.854.805 1.33 1.419 1.614.63.291.842.477.839.737-.004.398-.503.58-.969.58-.648 0-.992-.09-1.524-.312l-.209-.095-.227 1.33c.378.166 1.078.31 1.804.317 1.702 0 2.807-.797 2.82-2.03zm5.698 1.944l-1.311-5.937h-1.251c-.388 0-.678.106-.848.493l-2.405 5.444h1.7l.341-.893 2.074.003.197.89h1.503z"
  });
};

var masterCard = function masterCard() {
  return _react.default.createElement("path", {
    d: "M15.465 16.444c0 .193-.128.339-.319.339-.199 0-.321-.153-.321-.339 0-.186.122-.339.321-.339.19.001.319.147.319.339zm-6.814-.338c-.199 0-.321.153-.321.339 0 .186.122.339.321.339.19 0 .319-.146.319-.339 0-.193-.128-.339-.319-.339zm3.391-.011c-.164 0-.257.104-.281.257h.549c-.024-.164-.119-.257-.268-.257zm5.24.011c-.199 0-.321.153-.321.339 0 .186.122.339.321.339.19 0 .319-.146.319-.339 0-.193-.129-.339-.319-.339zm6.718-10.106v12c0 1.104-.896 2-2 2h-20c-1.104 0-2-.896-2-2v-12c0-1.104.896-2 2-2h20c1.104 0 2 .896 2 2zm-18.456 4.985c0 2.201 1.784 3.985 3.985 3.985.769 0 1.487-.219 2.096-.596-.967-.813-1.582-2.03-1.582-3.389s.616-2.576 1.582-3.389c-.609-.377-1.326-.596-2.096-.596-2.2 0-3.985 1.784-3.985 3.985zm2.346 5.324c0-.25-.159-.418-.416-.421-.135-.002-.274.04-.372.188-.073-.117-.188-.188-.35-.188-.113 0-.224.033-.31.157v-.131h-.23v1.058h.232v-.587c0-.184.102-.281.259-.281.153 0 .23.1.23.279v.589h.232v-.587c0-.184.106-.281.259-.281.157 0 .232.1.232.279v.589h.234v-.663zm1.297-.394h-.23v.128c-.073-.095-.184-.155-.334-.155-.297 0-.529.232-.529.556 0 .324.232.556.529.556.151 0 .261-.06.334-.155v.128h.23v-1.058zm1.164.74c0-.186-.139-.283-.37-.317l-.108-.016c-.1-.013-.179-.033-.179-.104 0-.078.075-.124.201-.124.135 0 .266.051.33.091l.1-.186c-.111-.073-.263-.111-.432-.111-.268 0-.44.128-.44.339 0 .173.128.279.365.312l.108.016c.126.018.186.051.186.111 0 .082-.084.128-.241.128-.159 0-.274-.051-.352-.111l-.108.179c.126.094.285.138.458.138.305 0 .482-.144.482-.345zm1.025.263l-.066-.197c-.069.04-.144.06-.204.06-.115 0-.153-.071-.153-.177v-.478h.376v-.21h-.376v-.321h-.232v.321h-.215v.21h.215v.483c0 .246.095.392.367.392.1-.001.215-.032.288-.083zm1.173-.474c-.002-.33-.206-.556-.503-.556-.31 0-.527.226-.527.556 0 .336.226.556.542.556.159 0 .305-.04.434-.148l-.113-.17c-.089.071-.201.111-.308.111-.148 0-.283-.069-.317-.259h.786l.006-.09zm.908-.526l-.164-.029c-.133 0-.219.062-.279.155v-.128h-.228v1.058h.23v-.594c0-.175.075-.272.226-.272l.144.027.071-.217zm.308.526c0-.204.135-.336.319-.339.1 0 .19.033.277.095l.111-.186c-.115-.091-.221-.126-.381-.126-.341 0-.564.235-.564.556s.222.556.563.556c.159 0 .266-.035.381-.126l-.111-.186c-.086.062-.177.095-.277.095-.183-.002-.318-.135-.318-.339zm1.916-.529h-.23v.128c-.073-.095-.184-.155-.334-.155-.297 0-.529.232-.529.556 0 .323.232.556.529.556.151 0 .261-.06.334-.155v.128h.23v-1.058zm.974.003l-.164-.029c-.133 0-.219.062-.279.155v-.128h-.228v1.058h.23v-.594c0-.175.075-.272.226-.272l.144.027.071-.217zm1.162-.428h-.23v.553c-.073-.095-.184-.155-.334-.155-.297 0-.529.232-.529.556 0 .323.232.556.529.556.151 0 .261-.06.334-.155v.128h.23v-1.483zm.639-4.505c0-2.201-1.785-3.985-3.985-3.985s-3.985 1.784-3.985 3.985c0 2.201 1.784 3.985 3.985 3.985s3.985-1.784 3.985-3.985z"
  });
};

var amex = function amex() {
  return _react.default.createElement("path", {
    d: "M18.53 10.339l-1.009 1.091-.978-1.091h-3.197v3.329h3.147l1.016-1.103.978 1.103h1.022l-1.486-1.655 1.486-1.674h-.979zm-2.439 2.639h-1.956v-.665h1.743v-.677h-1.743v-.608h1.994l.871.972-.909.978zm-8.715-2.752l-.01-.02h.01v.02zm2.997 2.37l-1.041-2.257h-1.298v3.147l-1.348-3.147h-1.184l-1.423 3.329h.865l.307-.746h1.655l.307.746h1.618v-2.608l1.154 2.608h.702l1.147-2.608.006 2.608h.784v-3.329h-1.292l-.959 2.257zm-4.84-.364l.545-1.329.545 1.329h-1.09zm16.467-8.232h-20c-1.104 0-2 .896-2 2v12c0 1.104.896 2 2 2h20c1.104 0 2-.896 2-2v-12c0-1.104-.896-2-2-2zm-1 10.32h-2.859l-.633-.721-.677.721h-10.107l-.301-.74h-.69l-.301.74h-2.432l2.031-4.64h4.771l.533 1.198.52-1.198h6.056l.614.708.658-.708h2.817l-2.038 2.332 2.038 2.308z"
  });
};

var discover = function discover() {
  return _react.default.createElement("path", {
    d: "M20.596 11.185h-.174v-.925h.184c.371 0 .573.156.573.453 0 .307-.202.472-.583.472zm-16.84-.889h-.16v2.021h.16c.385 0 .629-.074.816-.243.206-.184.33-.477.33-.77 0-.293-.124-.577-.33-.761-.197-.178-.431-.247-.816-.247zm20.244-4.296v12c0 1.104-.896 2-2 2h-20c-1.104 0-2-.896-2-2v-12c0-1.104.896-2 2-2h20c1.104 0 2 .896 2 2zm-4.173 6.835h.596v-1.228h.077l.825 1.228h.733l-.962-1.288c.449-.091.696-.398.696-.867 0-.572-.394-.902-1.082-.902h-.884v3.057zm-2.086 0h1.691v-.517h-1.095v-.825h1.055v-.518h-1.055v-.678h1.095v-.519h-1.691v3.057zm-3.208-3.057l1.297 3.135h.321l1.32-3.135h-.646l-.826 2.053-.815-2.053h-.651zm-3.094 1.545c0 .916.742 1.659 1.659 1.659.916 0 1.659-.743 1.659-1.659s-.743-1.659-1.659-1.659-1.659.743-1.659 1.659zm-2.528-.014c0 .898.705 1.595 1.613 1.595.257 0 .476-.05.747-.178v-.702c-.238.239-.449.335-.72.335-.6 0-1.027-.435-1.027-1.054 0-.587.44-1.05.999-1.05.284 0 .5.102.747.344v-.702c-.262-.133-.477-.188-.733-.188-.901 0-1.626.711-1.626 1.6zm-3.395 0c0-.902-.674-1.53-1.641-1.53h-.875v3.056h.871c.463 0 .797-.109 1.091-.353.348-.289.554-.724.554-1.173zm.87-1.531h-.596v3.056h.596v-3.056zm1.724 2.154c0 .248-.197.431-.463.431-.284 0-.513-.142-.651-.408l-.385.371c.275.403.605.582 1.058.582.62 0 1.054-.412 1.054-1.004 0-.486-.201-.705-.879-.953-.358-.132-.463-.22-.463-.385 0-.193.187-.339.444-.339.179 0 .325.073.481.247l.312-.408c-.256-.224-.563-.338-.898-.338-.541 0-.953.376-.953.876 0 .421.192.637.752.838.233.082.352.137.412.174.119.078.179.188.179.316zm14.89 1.217s-5.731 4.044-16.226 5.854h14.976c.69 0 1.25-.56 1.25-1.25v-4.604z"
  });
};

var diners = function diners() {
  return _react.default.createElement("path", {
    d: "M11.27 7.414c-2.528.001-4.576 2.05-4.577 4.578 0 2.528 2.049 4.576 4.577 4.577 2.528 0 4.577-2.049 4.578-4.577-.001-2.529-2.05-4.578-4.578-4.578zm-1.039 7.284c-1.088-.418-1.859-1.471-1.862-2.707.003-1.236.774-2.289 1.862-2.708v5.415zm2.077.001v-5.416c1.089.417 1.861 1.472 1.864 2.708-.002 1.237-.775 2.29-1.864 2.708zm9.692-10.699h-20c-1.104 0-2 .896-2 2v12c0 1.104.896 2 2 2h20c1.104 0 2-.896 2-2v-12c0-1.104-.896-2-2-2zm-9.444 13h-1.296c-2.767.013-5.043-2.228-5.043-4.956-.001-2.982 2.275-5.044 5.042-5.044h1.296c2.734 0 5.229 2.061 5.229 5.043 0 2.728-2.495 4.957-5.228 4.957z"
  });
};

var jcb = function jcb() {
  return _react.default.createElement("path", {
    d: "M22 4h-20c-1.104 0-2 .896-2 2v12c0 1.104.896 2 2 2h20c1.104 0 2-.896 2-2v-12c0-1.104-.896-2-2-2zm-12.55 11.315c0 .925-.751 1.667-1.667 1.667h-2.445v-3.507s.751.211 1.712.211c1.584 0 2.051-.614 2.051-1.365v-1.932h-1.428v1.941c0 .476-.311.824-.888.824-.485 0-.971-.146-1.438-.375v-4.112c0-.925.751-1.667 1.667-1.667h2.436v8.315zm4.615.018c0 .925-.751 1.667-1.667 1.667h-2.445v-3.846c.421.357 1.154.586 2.335.531.641-.027 1.31-.201 1.31-.201v-.705c-.339.165-.742.33-1.264.366-.897.073-1.438-.366-1.438-1.145 0-.769.54-1.209 1.438-1.145.522.037.925.192 1.264.366v-.705s-.678-.174-1.31-.201c-1.181-.055-1.914.174-2.335.531v-2.18c0-.924.751-1.666 1.667-1.666h2.445v8.333zm4.597-.009c0 .925-.751 1.667-1.667 1.667h-2.445v-3.388h2.582c.604 0 1.062-.33 1.062-.833 0-.467-.412-.769-.952-.806v-.018c.495-.064.76-.385.76-.76 0-.476-.394-.751-.925-.778l-.165-.009h-2.352v-1.732c0-.925.75-1.667 1.666-1.667h2.436v8.324zm-2.326-3.132l.119.009c.183.046.339.211.339.43 0 .229-.156.394-.339.43l-.119.009h-.961v-.879h.961zm-.961-.494v-.806h.87l.092.009c.183.027.339.174.339.394s-.156.366-.339.394l-.092.009h-.87z"
  });
};

var wrongCard = function wrongCard() {
  return _react.default.createElement("path", {
    d: "M4 15h5v1h-5v-1zm8-1h-8v-1h8v1zm1.502 4h-11.002c-.276 0-.5-.224-.5-.5v-6.5h12.82c1.184-1.23 2.842-2 4.68-2 .886 0 1.729.179 2.5.501v-3.501c0-1.104-.896-2-2-2h-18c-1.104 0-2 .896-2 2v12c0 1.104.896 2 2 2h12.82c-.553-.576-1.006-1.251-1.318-2zm-11.502-11.5c0-.276.224-.5.5-.5h17c.276 0 .5.224.5.5v1.5h-18v-1.5zm22 9c0 2.485-2.017 4.5-4.5 4.5s-4.5-2.015-4.5-4.5 2.017-4.5 4.5-4.5 4.5 2.015 4.5 4.5zm-3.086-2.122l-1.414 1.414-1.414-1.414-.707.708 1.414 1.414-1.414 1.414.707.708 1.414-1.414 1.414 1.414.708-.708-1.414-1.414 1.414-1.414-.708-.708z"
  });
};

var creditCard = function creditCard() {
  return _react.default.createElement("path", {
    d: "M22 4h-20c-1.104 0-2 .896-2 2v12c0 1.104.896 2 2 2h20c1.104 0 2-.896 2-2v-12c0-1.104-.896-2-2-2zm0 13.5c0 .276-.224.5-.5.5h-19c-.276 0-.5-.224-.5-.5v-6.5h20v6.5zm0-9.5h-20v-1.5c0-.276.224-.5.5-.5h19c.276 0 .5.224.5.5v1.5zm-9 6h-9v-1h9v1zm-3 2h-6v-1h6v1zm10-2h-3v-1h3v1z"
  });
};

var calendar = function calendar() {
  return _react.default.createElement("path", {
    d: "M24 2v22h-24v-22h3v1c0 1.103.897 2 2 2s2-.897 2-2v-1h10v1c0 1.103.897 2 2 2s2-.897 2-2v-1h3zm-2 6h-20v14h20v-14zm-2-7c0-.552-.447-1-1-1s-1 .448-1 1v2c0 .552.447 1 1 1s1-.448 1-1v-2zm-14 2c0 .552-.447 1-1 1s-1-.448-1-1v-2c0-.552.447-1 1-1s1 .448 1 1v2zm6.687 13.482c0-.802-.418-1.429-1.109-1.695.528-.264.836-.807.836-1.503 0-1.346-1.312-2.149-2.581-2.149-1.477 0-2.591.925-2.659 2.763h1.645c-.014-.761.271-1.315 1.025-1.315.449 0 .933.272.933.869 0 .754-.816.862-1.567.797v1.28c1.067 0 1.704.067 1.704.985 0 .724-.548 1.048-1.091 1.048-.822 0-1.159-.614-1.188-1.452h-1.634c-.032 1.892 1.114 2.89 2.842 2.89 1.543 0 2.844-.943 2.844-2.518zm4.313 2.518v-7.718h-1.392c-.173 1.154-.995 1.491-2.171 1.459v1.346h1.852v4.913h1.711z"
  });
};

var svgCreator = function svgCreator(Path) {
  return function (_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? "24" : _ref$size,
        _ref$viewBox = _ref.viewBox,
        viewBox = _ref$viewBox === void 0 ? "0 0 24 24" : _ref$viewBox,
        _ref$fill = _ref.fill,
        fill = _ref$fill === void 0 ? 'main' : _ref$fill,
        _ref$margin = _ref.margin,
        margin = _ref$margin === void 0 ? 0 : _ref$margin,
        extraCss = _ref.extraCss;
    return _react.default.createElement(_.FlexContainer, {
      justifyContent: "center",
      alignItems: "center",
      margin: margin,
      css: extraCss
    }, _react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: size,
      height: size,
      viewBox: viewBox,
      fill: _styledTheme.colors.colors[fill] || fill
    }, _react.default.createElement(Path, null)));
  };
};

var TrashCan = svgCreator(trashCan);
exports.TrashCan = TrashCan;
var SortingArrow = svgCreator(sortingArrow);
exports.SortingArrow = SortingArrow;
var DownArrow = svgCreator(downArrow);
exports.DownArrow = DownArrow;
var NavArrow = svgCreator(navArrow);
exports.NavArrow = NavArrow;
var AlertNegative = svgCreator(alertNegative);
exports.AlertNegative = AlertNegative;
var Info = svgCreator(info);
exports.Info = Info;
var CheckMark = svgCreator(checkMark);
exports.CheckMark = CheckMark;
var XMark = svgCreator(xMark);
exports.XMark = XMark;
var EMail = svgCreator(email);
exports.EMail = EMail;
var NegativeResult = svgCreator(negativeResult);
exports.NegativeResult = NegativeResult;
var Warning = svgCreator(warningTriangle);
exports.Warning = Warning;
var Floppy = svgCreator(floppySave);
exports.Floppy = Floppy;
var Eraser = svgCreator(eraser);
exports.Eraser = Eraser;
var Visa = svgCreator(visa);
exports.Visa = Visa;
var MasterCard = svgCreator(masterCard);
exports.MasterCard = MasterCard;
var Amex = svgCreator(amex);
exports.Amex = Amex;
var Discover = svgCreator(discover);
exports.Discover = Discover;
var Diners = svgCreator(diners);
exports.Diners = Diners;
var Jcb = svgCreator(jcb);
exports.Jcb = Jcb;
var WrongCard = svgCreator(wrongCard);
exports.WrongCard = WrongCard;
var CreditCardPlaceHolder = svgCreator(creditCard);
exports.CreditCardPlaceHolder = CreditCardPlaceHolder;
var Calendar = svgCreator(calendar);
exports.Calendar = Calendar;